import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import AccountHeader from "../../Component/Header/account_header";
import DataContext from "../../Component/context";
import Footer from "../../Component/Footer";
import { ApiService } from "../../Component/services/apiServices";

const AccountOverview = () => {
  const navigate = useNavigate();
  const contextValues = useContext(DataContext)
  const [isloading, setIsLoading] = useState(true)
  const isFetched = useRef(false); // Tracks if function has already run

  const getUserData = useCallback(async () => {
    if (isFetched.current) return; // Prevents duplicate execution
    isFetched.current = true;

    try {
      const res = await ApiService.fetchData("profile-data");

      if (res?.status === "success") {
        contextValues.setUserData(res?.userData);
      } else if (res?.status === "session_expired") {
        localStorage.removeItem("USER_TOKEN");
        window.location.href = "/";
        return;
      }
    } catch (error) {
      console.error("An error occurred while fetching user data:", error);
    } finally {
      setIsLoading(false);
    }
  }, []); // Empty array ensures function remains stable

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  const logoutProcess = () => {
    const confirmed = window.confirm("Are you sure ? Want to log out");
    if (confirmed) {
      const user_Token = localStorage.getItem('USER_TOKEN')
      if (user_Token && user_Token !== null) {
        localStorage.removeItem("USER_TOKEN")
      }
      navigate('/', { replace: true });
    }
  }

  return (
    <>
      <AccountHeader heading={'My Account'}></AccountHeader>

      <div id="appCapsule">
        <div className="p-15">
          <div className="mprofile" onClick={() => { navigate('/account/profile') }}>
            <div className="mprofile-content">
              {isloading ? <h6 className="mb-0">
                <Skeleton width={'250px'}></Skeleton>
              </h6> : <h6 className="mb-0">
                Hi! {contextValues.UserData?.user_name?.toUpperCase()}
              </h6>}
              {isloading ? <>  <p className="mb-2"><Skeleton width={'200px'}></Skeleton></p>
                <p className="mb-0 tx-14 tx-primary"><Skeleton width={'50px'}></Skeleton></p></> : <>
                <p className="mb-2">{contextValues.UserData?.user_email}</p>
                <p className="mb-0 tx-14 tx-primary">Edit Profile</p>
              </>}
            </div>
            {isloading ? <>
              <div className="mprofile-media">
                <Skeleton width={'50px'} height={'50px'} circle></Skeleton>
              </div>
            </> : <>
              <div className="mprofile-media">
                <img src="/img/user.png" alt="Daadi's Kitchen" />
              </div>
            </>}
          </div>

          {isloading ?
            <div className="macc-list">
              <ul>
                {[...Array(5)].map((item, index) => (
                  <li key={index}>
                    <div className="macc-list-icon">
                      <Skeleton width={'50px'} height={'50px'} circle></Skeleton>
                    </div>
                    <div className="macc-list-content">
                      <p className="mb-0 fw600"><Skeleton width={'50px'}  ></Skeleton></p>
                      <span className="tx-gray tx-11">
                        <Skeleton width={'150px'}  ></Skeleton>
                      </span>
                    </div>

                  </li>
                ))}
              </ul>
            </div> :
            <div className="macc-list">
              <ul>
                <li onClick={() => navigate("/account/orders")}>
                  <div className="macc-list-icon">
                    <img src="/img/order.png" alt="Daadi's Kitchen" />
                  </div>
                  <div className="macc-list-content">
                    <p className="mb-0 fw600">My Orders</p>
                    <span className="tx-gray tx-11">
                      Check your order status
                    </span>
                  </div>
                  <i className="ri-arrow-right-line"></i>
                </li>
                <li onClick={() => navigate("/account/address")}>
                  <div className="macc-list-icon">
                    <img src="/img/pin.png" alt="Daadi's Kitchen" />
                  </div>
                  <div className="macc-list-content">
                    <p className="mb-0 fw600"> Address Book</p>
                    <span className="tx-gray tx-11">
                      Saved addresses for hassle-free checkout
                    </span>
                  </div>
                  <i className="ri-arrow-right-line"></i>
                </li>
                <li onClick={() => navigate("/account/wallet")}>
                  <div className="macc-list-icon">
                    <img src="/img/wallet.png" alt="Daadi's Kitchen" />
                  </div>
                  <div className="macc-list-content">
                    <p className="mb-0 fw600">My Wallet</p>
                    <span className="tx-gray tx-11">
                      Add Money to your Wallet
                    </span>
                  </div>
                  <i className="ri-arrow-right-line"></i>
                </li>
                <li onClick={() => navigate("/account/change-password")}>
                  <div className="macc-list-icon">
                    <img src="/img/changepassword.png" alt="Daadi's Kitchen" />
                  </div>
                  <div className="macc-list-content">
                    <p className="mb-0 fw600">Change Password</p>
                    <span className="tx-gray tx-11">
                      Keep your account secure.
                    </span>
                  </div>
                  <i className="ri-arrow-right-line"></i>
                </li>
                <li onClick={() => navigate("/account/about-us")}>
                  <div className="macc-list-icon">
                    <img src="/img/information.png" alt="Daadi's Kitchen" />
                  </div>
                  <div className="macc-list-content">
                    <p className="mb-0 fw600"> About Us</p>
                    <span className="tx-gray tx-11">
                      Policies, terms of use etc
                    </span>
                  </div>
                  <i className="ri-arrow-right-line"></i>
                </li>
                <li onClick={() => navigate("/account/help-support")}>
                  <div className="macc-list-icon">
                    <img src="/img/helpsupport.png" alt="Daadi's Kitchen" />
                  </div>
                  <div className="macc-list-content">
                    <p className="mb-0 fw600">Help & Support</p>
                    <span className="tx-gray tx-11">
                      Feel free to contact us
                    </span>
                  </div>
                  <i className="ri-arrow-right-line"></i>
                </li>
              </ul>
            </div>}
          {!isloading && <button className="logoutbtn mt-30" onClick={() => {
            logoutProcess();
          }}>
            Logout From Daadi Kitchen
          </button>}
        </div>


      </div>
      <Footer />
    </>
  );
};
export default AccountOverview;
